import { isEmpty } from 'lodash'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'srcReact/components/common2/Button'
import IconButton from 'srcReact/components/common2/IconButton'
import Modal from 'srcReact/components/common2/Modal'
import SuccessMessage from 'srcReact/components/common2/SuccessMessage'
import { TextArea } from 'srcReact/components/common2/TextArea'
import Icon from 'srcReact/components/icons/Icon'
import { moderationReportActions } from 'srcReact/ModerationReportPage'
import styles from './styles.module.scss'

function SuspendModal({ isOpen, hideModal, objectType, onSuspend, objectName }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    common: { isMobile, isNative },
    moderationReport: {
      suspend: { loading, data, error }
    }
  } = useSelector((state) => state)

  const [successMessage, setSuccessMessage] = useState('')
  const [message, setMessage] = useState({
    name: 'message',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })

  useEffect(() => {
    return () => {
      dispatch(moderationReportActions.clearSuspendData())
    }
  }, [])

  useEffect(() => {
    if (data && !loading) {
      if (data && data.moderator_action === 'suspend') {
        const objectTypeInitCap = objectType.charAt(0).toUpperCase() + objectType.slice(1)
        setSuccessMessage(t('moderationReport.suspend.successMessage', { object: objectTypeInitCap, objectName }))
        setTimeout(() => hideModal(), 1500)
      }
    }
  }, [data, loading])

  const handleSubmit = (e) => {
    e.preventDefault()
    if (isEmpty(message.value)) {
      setMessage({
        ...message,
        hasError: true,
        errorMessage: t('moderationReport.suspend.error')
      })
      return false
    }

    if (onSuspend) {
      onSuspend(message.value)
    }
  }

  const handleChange = (e) => {
    const value = e.target.value
    setMessage({
      ...message,
      value: value,
      hasError: false,
      errorMessage: ''
    })
  }

  const handleBlur = () => {}

  return (
    <Modal
      {...(isMobile || isNative ? {} : { customContentStyle: { maxWidth: '40rem' } })}
      isOpen={isOpen}
      handleClose={hideModal}
      title={t('moderationReport.suspend.title', { object: objectType })}>
      <form className={styles.form}>
        <TextArea
          rows={8}
          isRequired={message.isRequired}
          label={t('moderationReport.suspend.label')}
          fieldInfo={message}
          onChange={handleChange}
          onBlur={handleBlur}
          customWrapperCss={styles.textboxFormWrapper}
          placeholder={t('moderationReport.suspend.placeholder')}
        />
        {successMessage && <SuccessMessage html={successMessage} />}
        <div className={styles.footer}>
          <div className={styles.info}>{t(`moderationReport.suspend.info.${objectType}`)}</div>
          <IconButton
            type='button'
            onClick={handleSubmit}
            iconName='send-copy'
            iconSize='large24'
            className={styles.btnSend}
          />
        </div>
      </form>
    </Modal>
  )
}

export default SuspendModal
